

 var header = document.querySelector('.header');
 
window.addEventListener('scroll', function () {
    if (window.scrollY > 80) { // Adjust the threshold as needed
        header.classList.add('header--sticky');
    } else {
        header.classList.remove('header--sticky');
    }
});